
export default function Solution() {
  return (
    <section id="solution" className="solution-section py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            産業用エアゾール式簡易消火具
          </h2>
          <div className="text-6xl font-bold text-red-600 mb-8">FIRE OUT</div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <div
              className="rounded-3xl overflow-hidden shadow-2xl"
              style={{
                width: '100%',
                height: '500px',
              }}
            >
              <img
                src="https://static.readdy.ai/image/929818ef5c2fcaad39934da27e65f1be/656958eab8b9a1df52e9dd3756b63396.jpeg"
                alt="FIRE OUT 製品画像"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="space-y-8">
            <div>
              <h3 className="solution-subheading text-2xl md:text-3xl font-bold text-gray-900 mb-6">
                <span className="solution-heading-pc">「汚さない」という、最強の資産保全</span>
                <span className="solution-heading-mobile">
                  「汚さない」という、<br />最強の資産保全
                </span>
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                対象物にダメージを与えない中性液体消火剤。
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                使用後はサッと拭き取るだけ。
                <strong className="text-green-600 text-xl">「即時復旧」</strong>
                を可能にする、製造業のための危機管理ツール。
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="bg-green-50 rounded-xl p-6 text-center">
                <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-drop-line text-2xl text-white"></i>
                </div>
                <p className="text-sm font-semibold text-gray-900">中性液体消火剤</p>
              </div>
              <div className="bg-blue-50 rounded-xl p-6 text-center">
                <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-refresh-line text-2xl text-white"></i>
                </div>
                <p className="text-sm font-semibold text-gray-900">即時復旧可能</p>
              </div>
              <div className="bg-purple-50 rounded-xl p-6 text-center">
                <div className="w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-shield-check-line text-2xl text-white"></i>
                </div>
                <p className="text-sm font-semibold text-gray-900">機械を守る</p>
              </div>
              <div className="bg-orange-50 rounded-xl p-6 text-center">
                <div className="w-12 h-12 bg-orange-600 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-sparkling-line text-2xl text-white"></i>
                </div>
                <p className="text-sm font-semibold text-gray-900">拭き取るだけ</p>
              </div>
            </div>

            <a
              href="https://fireout.stores.jp/inquiry"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block w-full bg-red-600 text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-red-700 transition-all transform hover:scale-105 shadow-lg text-center whitespace-nowrap cursor-pointer"
            >
              無料お見積り・導入のご相談
            </a>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .solution-section {
            padding-top: 2rem !important;
            padding-bottom: 2rem !important;
          }
          .solution-subheading {
            font-size: 1.2rem !important;
            line-height: 1.6 !important;
          }
          .solution-heading-pc {
            display: none;
          }
          .solution-heading-mobile {
            display: inline;
          }
        }
        @media (min-width: 769px) {
          .solution-heading-pc {
            display: inline;
          }
          .solution-heading-mobile {
            display: none;
          }
        }
      `}</style>
    </section>
  );
}
